module.exports = __webpack_public_path__ + "files/3910c0a86d9aabc33b9c50f0ad3688dd.png";